<div class="change-password-container" [ngClass]="{
    'max-w-settings': context === 'password',
    'max-w-default': context === 'default'
}">
    <h2 *ngIf="context !== 'password'" class="change-password-title">Change Password</h2>

    <form *ngIf="formVisible" [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="form-style" autocomplete="off">
        <div class="form-group">
            <label for="currentPassword" *ngIf="context !== 'password'">Old Password</label>
            <label for="currentPassword" *ngIf="context === 'password'">Current password</label>
            <div class="password-input-wrapper">
                <input [type]="showOldPassword ? 'text' : 'password'" id="currentPassword"
                    placeholder="Enter your current password" formControlName="currentPassword" class="password-input"
                    autocomplete="current-password" [ngClass]="{'invalid-input': isFieldInvalid('currentPassword')}">
                <button type="button" class="toggle-password-button" (click)="togglePasswordVisibility('old')">
                    <i class="visibility-icon" [ngClass]="showOldPassword ? 'visible' : 'hidden'"></i>
                </button>
            </div>
            <div class="error-message" *ngIf="isFieldInvalid('currentPassword')">
                <span *ngIf="passwordForm.get('currentPassword')?.errors?.['required']">Please enter a current
                    password.</span>
            </div>
        </div>

        <div class="form-group mbv-btom">
            <label for="newPassword">New password</label>
            <div class="password-input-wrapper">
                <input [type]="showNewPassword ? 'text' : 'password'" id="newPassword"
                    placeholder="Enter your new password" formControlName="newPassword" class="password-input"
                    autocomplete="new-password" [ngClass]="{'invalid-input': isFieldInvalid('newPassword')}">
                <button type="button" class="toggle-password-button" (click)="togglePasswordVisibility('new')">
                    <i class="visibility-icon" [ngClass]="showNewPassword ? 'visible' : 'hidden'"></i>
                </button>
            </div>
            <!-- <div class="error-message" *ngIf="isFieldInvalid('newPassword')">
                <span *ngIf="passwordForm.get('newPassword')?.errors?.['pattern']">Please enter a new password</span>
                <span *ngIf="passwordForm.get('newPassword')?.errors?.['required']">Please enter a new password</span>
                <span *ngIf="passwordForm.get('newPassword')?.errors?.['minlength']">Password must be at least 8
                    characters</span>
                </div> -->
            <div class="error-message" *ngIf="isFieldInvalid('newPassword')">
                <small *ngIf="passwordForm.get('newPassword')?.errors?.['required']">Password is required</small>
                <!-- <small *ngIf="passwordForm.get('newPassword')?.errors?.['minlength']">Minimum 8 characters</small> -->
                <small class="break-wrd" *ngIf="passwordForm.get('newPassword')?.errors?.['pattern']">
                    Password must be at least 8 characters and include uppercase, lowercase, number, and special
                    character.
                </small>
            </div>
        </div>

        <div class="form-group">
            <label for="confirmPassword">Confirm new password</label>
            <div class="password-input-wrapper">
                <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword"
                    placeholder="Enter your confirm new password" formControlName="confirmPassword"
                    class="password-input" autocomplete="new-password"
                    [ngClass]="{'invalid-input': isFieldInvalid('confirmPassword')}">
                <button type="button" class="toggle-password-button" (click)="togglePasswordVisibility('confirm')">
                    <i class="visibility-icon" [ngClass]="showConfirmPassword ? 'visible' : 'hidden'"></i>
                </button>
            </div>
            <div class="error-message" *ngIf="isFieldInvalid('confirmPassword')">
                <span *ngIf="passwordForm.get('confirmPassword')?.errors?.['required']">Confirm password is
                    required</span>
                <span *ngIf="passwordForm.get('confirmPassword')?.errors?.['matching']">Passwords don't match</span>
            </div>
        </div>

        <div class="form-actions">
            <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
            <button type="submit" class="btn-save">{{this.isSubmitting ? "Saving..." : "Save"}}</button>
        </div>
    </form>
</div>